// @core/api/endpoints/bootstrap/probe_vault_status.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ProbeVaultStatusResponse,
} from '../../../types/bootstrap';

const BASE_PATH = '/bootstrap';

/**
 * Probe vault status
 * Probes the secret service health endpoint to get the current seal status. Used by the wizard to show real-time vault state.
 * @public This endpoint does not require authentication
 */
export async function ProbeVaultStatus(
  params?: {
  },
  options?: RequestOptions
): Promise<ProbeVaultStatusResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/setup/vault/status`;
  const requestOptions = { ...options, skipAuth: true };
  return client.get<ProbeVaultStatusResponse>(requestPath, { ...requestOptions, params });
}
